export default class ProductRating {
	constructor(query) {
		let ratings = $(query + ':not(.star-init)');
		ratings.each((index, el) => {
			var score = $(el).data('score');
			if(score === undefined || score <= 0) {
				return;
			}
			let starEl = $(el).find('.stars-inner');
			if(starEl.length <= 0) {
				return;
			}
			let ratingPercentage = this.getRatingPercentage(score);
			starEl.width(ratingPercentage);
			$(el).addClass('star-init');
		});
	}
	
	getRatingPercentage(rating) {
		var ratingTotal = 5;
		var ratingPercentage = (rating / ratingTotal) * 100;
		ratingPercentage = ratingPercentage + '%';
		return ratingPercentage;
	}
}



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/modules/module.rating.js